/** The page's own URL, and a full page navigation out of the app. Injectable so it can be tested. */
export interface BrowserLocation {
  href: () => string;
  assign: (url: string) => void;
  /** Leaves without adding a history entry, so the back button can't return to this page. */
  replace: (url: string) => void;
}

export const windowLocation: BrowserLocation = {
  href: () => window.location.href,
  assign: (url) => window.location.assign(url),
  replace: (url) => window.location.replace(url),
};
